/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletChecklistIcon20Solid = forwardRef('TextBulletChecklistIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.707 4.207a1 1 0 0 0-1.414-1.414L4.25 4.836l-.543-.543a1 1 0 0 0-1.414 1.414l.896.897a1.5 1.5 0 0 0 2.122 0l2.396-2.397Z" }),
        React.createElement("path", { d: "M9 5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M10 9a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2h-7Z" }),
        React.createElement("path", { d: "M10 14a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Z" }),
        React.createElement("path", { d: "M7.707 7.793a1 1 0 0 1 0 1.414l-2.396 2.397a1.5 1.5 0 0 1-2.122 0l-.896-.897a1 1 0 0 1 1.414-1.414l.543.543 2.043-2.043a1 1 0 0 1 1.414 0Z" }),
        React.createElement("path", { d: "M7.707 14.207a1 1 0 1 0-1.414-1.414L4.25 14.836l-.543-.543a1 1 0 0 0-1.414 1.414l.896.897a1.5 1.5 0 0 0 2.122 0l2.396-2.397Z" })));
});
